import {NgModule} from '@angular/core';
import {SharedModule} from '../../../shared/shared.module';
import {RouterModule, Routes} from '@angular/router';

import {CdnifyPipe} from '../../../shared/pipes/cdnify.pipe';
import {CruiseStepMarkersPipe} from './pipes/cruise-step-markers.pipe';
import {ExcursionPortsPipe} from './pipes/excursion-ports.pipe';
import {ImageByCodePipe} from '../../../shared/pipes/image-by-code.pipe';
import {CruiseSolutionsGroupedByDatePipe} from './pipes/cruise-solutions-grouped-by-date.pipe';
import {CruiseCabinsGroupedByTypePipe} from './pipes/cruise-cabins-grouped-by-type.pipe';
import {AllCabinImagesByTypePipe} from './pipes/all-cabin-images-by-type.pipe';
import {AllCabinInfoByTypeFromShipservicePipe} from './pipes/all-cabin-info-by-type-from-shipservice.pipe';

import {CruiseDetailBreadcrumbComponent} from './components/cruise-detail-breadcrumb/cruise-detail-breadcrumb.component';
import {CruiseDetailContentAsideComponent} from './components/cruise-detail-content-aside/cruise-detail-content-aside.component';
import {
  CruiseDetailContentExcursionsComponent
} from './components/cruise-detail-content-excursions/cruise-detail-content-excursions.component';
import {
  CruiseDetailContentItineraryComponent
} from './components/cruise-detail-content-itinerary/cruise-detail-content-itinerary.component';
import {CruiseDetailContentOffersComponent} from './components/cruise-detail-content-offers/cruise-detail-content-offers.component';
import {CruiseDetailContentShipComponent} from './components/cruise-detail-content-ship/cruise-detail-content-ship.component';
import {CruiseDetailContentTabsComponent} from './components/cruise-detail-content-tabs/cruise-detail-content-tabs.component';
import {CruiseDetailGalleryComponent} from './components/cruise-detail-gallery/cruise-detail-gallery.component';
import {CruiseDetailHeaderComponent} from './components/cruise-detail-header/cruise-detail-header.component';
import {CruiseDetailSliderComponent} from './components/cruise-detail-slider/cruise-detail-slider.component';
import {CruiseDetailComponent} from './cruise-detail.component';
import {DetailPriceGridComponent} from './components/detail-price-grid/detail-price-grid.component';
import {CruiseDetailGenericPageComponent} from '../cruise-detail-generic-page/cruise-detail-generic-page.component';
import {
  CruiseDetailGenericPageDatesComponent
} from '../cruise-detail-generic-page/cruise-detail-generic-page-dates/cruise-detail-generic-page-dates.component';
import {
  CruiseDetailGenericPageRecapComponent
} from '../cruise-detail-generic-page/cruise-detail-generic-page-recap/cruise-detail-generic-page-recap.component';


const routes: Routes = [
  {path: ':source/:hasFlight/pacchetto/:packetDescription/volo/:flightString/dal/:fromDate/al/:toDate', component: CruiseDetailComponent},
  //  Nuova rotta dettaglio cruise generica
  {path: ':packetDescription/:source', component: CruiseDetailGenericPageComponent}

];

@NgModule({
  declarations: [
    CruiseDetailComponent,
    CruiseDetailBreadcrumbComponent,
    CruiseDetailContentAsideComponent,
    CruiseDetailContentOffersComponent,
    CruiseDetailContentTabsComponent,
    CruiseDetailHeaderComponent,
    CruiseDetailSliderComponent,
    CruiseDetailContentItineraryComponent,
    CruiseDetailContentExcursionsComponent,
    CruiseDetailContentShipComponent,
    CruiseStepMarkersPipe,
    CruiseSolutionsGroupedByDatePipe,
    CruiseCabinsGroupedByTypePipe,
    AllCabinImagesByTypePipe,
    AllCabinInfoByTypeFromShipservicePipe,
    ExcursionPortsPipe,
    CruiseDetailGalleryComponent,
    DetailPriceGridComponent,
    CruiseDetailGenericPageComponent,
    CruiseDetailGenericPageDatesComponent,
    CruiseDetailGenericPageRecapComponent,
  ],
  imports: [
    SharedModule,
    RouterModule.forChild(routes)
  ],
  exports: [
    CruiseDetailComponent,
    CruiseDetailGenericPageComponent,
    RouterModule
  ],
  providers: [CruiseStepMarkersPipe, CdnifyPipe, ImageByCodePipe, ExcursionPortsPipe]
})
export class CruiseDetailPageModule {
}
